
const captchaToken = "wakelet-captcha-token";

export const CaptchaStore = {
  set: (token: string) => {
    sessionStorage.setItem(captchaToken, token);
  },
  get: (): string | null => {
    return sessionStorage.getItem(captchaToken)
  },
  clear: () => {
    sessionStorage.removeItem(captchaToken);
  }
}